import {Wrapper} from './style';
import logo from '../../logo.svg';

export const Navbar = () => {
    return (
        <Wrapper>
            <img src={logo} alt="Logo" style={{ height: '100%', marginRight: '100%' }} />
        </Wrapper>
    )
}